import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import * as _ from 'lodash-es';
import { TranslationEntry } from '@app/shared/models/translatable';

export class InsuranceTypes {

    public static readonly ALL: TranslationEntry[] = [
        { key: 'FULL_COMPREHENSIVE', trans: marker('case.insurance_covered_claim_type.full_comprehensive')} ,
        { key: 'PARTIAL_COMPREHENSIVE', trans: marker('case.insurance_covered_claim_type.partial_comprehensive')} ,
        { key: 'LIABILITY', trans: marker('case.insurance_covered_claim_type.liability')}
    ];

    public static getTypeByKey(key: string): TranslationEntry {
        return _.find(this.ALL, (type: TranslationEntry) => type.key === key);
    }

    public static get FULL_COMPREHENSIVE() {
        return InsuranceTypes.getTypeByKey('FULL_COMPREHENSIVE');
    }

    public static get PARTIAL_COMPREHENSIVE() {
        return InsuranceTypes.getTypeByKey('PARTIAL_COMPREHENSIVE');
    }

    public static get LIABILITY() {
        return InsuranceTypes.getTypeByKey('LIABILITY');
    }
}
